import { getLegalUrl } from '@change-corgi/config/help';
import { useI18n } from '@change-corgi/core/react/i18n';

import { useLocale } from 'src/app/shared/hooks/l10n';

import { processLinkGroup } from './processLinkGroup';
import type { LinkGroup } from './types';
import { useCountryCodes } from './useCountryCodes';

export function useCompanyLinks(): LinkGroup | null {
	const { translate } = useI18n();
	const locale = useLocale();
	const countryCodes = useCountryCodes();

	return processLinkGroup({
		title: translate('fe.components.footer.company'),
		links: [
			{ href: '/about', title: translate('fe.components.footer.about') },
			{
				href: getLegalUrl(locale, countryCodes),
				title: translate('fe.components.footer.legal_disclosure'),
			},
			{ href: '/impact', title: translate('fe.components.footer.impact') },
			{ href: 'https://careers.change.org', title: translate('fe.components.footer.careers') },
			{ href: '/about/team', title: translate('fe.components.footer.team') },
		],
	});
}
